import { ICoOwner, IHome, IHomeFormValues } from "features/homes"
import { IStrapiEntity } from "services/strapi"
import { isEmail, isNotEmpty, matches, isInRange } from "@mantine/form"
import {IRefinanceFormValues} from "features/homes/components/home.refinance-options/home.refinance-options.types";

export class HomeUtils {
  static transformInitialValues(home?: IStrapiEntity<IHome>): IHomeFormValues {
    if (!home) {
      return {}
    } else {
      const { ...rest } = home.attributes
      return {
        id: home.id,
        ...rest,
        yearBuilt: rest.yearBuilt
          ? (() => {
              try {
                return parseInt(rest.yearBuilt as string)
              } catch (error) {
                return undefined
              }
            })()
          : undefined,
        floors: rest.floors
          ? (() => {
              try {
                return parseInt(rest.floors as string)
              } catch (error) {
                return undefined
              }
            })()
          : undefined,
        parkingSpaces: rest.parkingSpaces
          ? (() => {
              try {
                return parseInt(rest.parkingSpaces as string)
              } catch (error) {
                return undefined
              }
            })()
          : undefined,
        hasHoa: rest.hasHoa ? "true" : "false",
        hasSolar: rest.hasSolar ? "true" : "false",
      }
    }
  }

  static transformCoOwnerInitialValues(co?: IStrapiEntity<ICoOwner>): ICoOwner {
    if (!co) {
      return {
        phoneNumber: "",
        emailAddress: "",
        firstName: "",
        lastName: "",
        fullName: "",
      }
    } else {
      const { ...rest } = co.attributes
      return {
        id: co.id,
        ...rest,
      }
    }
  }

  static getValidationSchema(): Partial<Record<keyof IHomeFormValues, any>> {
    return {}
  }

  static getCoOwnersValidationSchema(): Partial<Record<keyof ICoOwner, any>> {
    return {
      emailAddress: isEmail(),
      phoneNumber: matches(
        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
        "Invalid Phone Number"
      ),
      firstName: isNotEmpty(),
      lastName: isNotEmpty(),
    }
  }

  static transformRefinanceForm(values: IRefinanceFormValues):Partial<Record<keyof IRefinanceFormValues, any>> {
    const {originalLoanDate, ...rest} = values
    return {
      ...rest,
      originalLoanDate: originalLoanDate.toISOString()
    }
  }

  static getRefinanceValidationSchema(): Partial<Record<keyof IRefinanceFormValues, any>> {
    return {
      currentLoanBalance: isNotEmpty(),
      currentInterestRate: isNotEmpty(),
      monthlyPaymentAmount: isNotEmpty(),
      originalLoanAmount: isNotEmpty(),
      originalLoanDate: isNotEmpty(),
      currentLoanType: isNotEmpty(),
      currentLenderName: isNotEmpty(),
      loanRemainingYears: isNotEmpty(),
      reasonForRefinance: isNotEmpty(),
      desiredLoanAmount: isNotEmpty(),
      preferredLoanTermYears: isNotEmpty(),
      cashOutAmount: isNotEmpty(),
      closingTimelineDays: isNotEmpty()
    }
  }

  static isBeingSold(home?: IStrapiEntity<IHome>) {
    if (!home) return false

    return (
      home?.attributes.sellStatus === "simple" ||
      home?.attributes.sellStatus === "cash"
    )
  }
}
